import React, { useMemo } from 'react';
import { Box, Input, FormField, Heading } from '@wix/design-system';
export const Credentials = props => {
  const {
    fields,
    shouldShowErrorForBlankFields,
    credentials,
    disabled,
    setCredentials
  } = props;
  const invalidFieldsNames = useMemo(() => {
    return fields == null ? void 0 : fields.filter(_ref => {
      let {
        name,
        validationRegexp
      } = _ref;
      if (!validationRegexp) {
        return false;
      }
      return !new RegExp(validationRegexp).test(credentials[name]);
    }).map(_ref2 => {
      let {
        name
      } = _ref2;
      return name;
    });
  }, [fields, credentials]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginBottom: "SP2",
    gap: 2
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "tiny"
  }, "Required details"), /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, fields == null ? void 0 : fields.filter(_ref3 => {
    let {
      hiddenValue
    } = _ref3;
    return !hiddenValue;
  }).map(field => {
    const isEmpty = !credentials[field.name].trim();
    const isInvalid = (() => {
      if (isEmpty) {
        return shouldShowErrorForBlankFields;
      }
      return !!(credentials[field.name] && invalidFieldsNames != null && invalidFieldsNames.includes(field.name));
    })();
    const statusMessage = (() => {
      if (isEmpty && shouldShowErrorForBlankFields) {
        return 'Field cannot be empty';
      }
      if (isInvalid) {
        return 'Enter valid value';
      }
      return undefined;
    })();
    return /*#__PURE__*/React.createElement(FormField, {
      label: field.title,
      key: field.name
    }, /*#__PURE__*/React.createElement(Input, {
      value: credentials[field.name],
      name: field.name,
      status: isInvalid ? 'error' : undefined,
      statusMessage: statusMessage,
      disabled: disabled,
      onChange: e => {
        setCredentials(prev => ({
          ...prev,
          [field.name]: e.target.value
        }));
      }
    }));
  }))));
};
//# sourceMappingURL=Credentials.js.map